import React from 'react';
import { InvoiceFormView } from '../invoices/InvoiceFormView';

/**
 * Formulário de criação de nota fiscal para o módulo de Suprimentos.
 * Filtra naturezas de operação para exibir apenas:
 * - transaction_type IN ('E', 'S') com final_customer = false
 * - transaction_type = 'E' com final_customer = true (devolução de venda ao consumidor)
 *
 * Reutiliza o InvoiceFormView existente com scope 'supply' para carregar as naturezas filtradas.
 */
export const SupplyInvoiceFormView: React.FC = () => {
  return (
    <InvoiceFormView
      transactionTypeScope="supply"
      listPath="/supply-invoices"
    />
  );
};
